import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, signal, inject } from '@angular/core';
import { MenuItem } from '../header.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonComponent, ButtonThemes } from '@shared/components/button/button.component';
import { EXTERNAL_LINKS } from '@shared/constants/external-links.constants';
import { TabService } from '@shared/services/tab/tab.service';
import { buildUrl } from '@shared/utilities/common.utils';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { OrderRequestModalComponent } from '@shared/components/order-request-modal/order-request-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'avenir-mobile-side-nav',
    imports: [
        CommonModule,
        ButtonComponent
    ],
    templateUrl: './mobile-side-nav.component.html',
    styleUrl: './mobile-side-nav.component.scss'
})
export class MobileSideNavComponent implements OnChanges {
  modalService = inject(NgbModal);

  readonly BUTTON_THEME = ButtonThemes;
  
  @Input() customerId: string = '';
  @Input() isLoggedIn: boolean = false;
  @Input() loggedInMenuItems!: MenuItem[];
  @Input() phoneNumber: string = '1-800-555-1212';
  @Input() bottomMenuItems!: MenuItem[];
  @Input() showSideNav: boolean = false;
  @Output() hideSideNav = new EventEmitter<boolean>;
  selectedTab = signal<number>(10);
  lastSelectedTab: any;

  mobileLoggedInMenuItems!: MenuItem[];

  orderPropaneLabel = $localize `:@@orderPropaneLabel:Request a Delivery`
  contactUsLabel = $localize `:@@ocontactUsLabel:Contact Us`

  constructor(
    private router: Router,
    private tabService: TabService
  ){}

  ngOnInit(){
    this.mobileLoggedInMenuItems = this.loggedInMenuItems.filter(item => item.inMobile);

    this.tabService.selectedTab$.subscribe(tab => {
      this.selectedTab.set(parseInt(tab));
    });

    // this.lastSelectedTab = localStorage.getItem('selectedTab');
    // if(this.lastSelectedTab){
    //   this.selectedTab.set(parseInt(this.lastSelectedTab));
    // }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isLoggedIn']) {
      this.isLoggedIn = changes['isLoggedIn'].currentValue;
    }

    if (changes['loggedInMenuItems']) {
      this.loggedInMenuItems = changes['loggedInMenuItems'].currentValue;
      this.mobileLoggedInMenuItems = this.loggedInMenuItems.filter(item => item.inMobile);
    }
  }

  goToPage(url: string, event: Event, redirect: boolean, i: number){
    localStorage.setItem('selectedTab', i.toString());
    if(!redirect){
      event.stopPropagation();
    }
    this.selectedTab.set(i);
    this.router.navigateByUrl(url);
    this.hideSideNav.emit(false);
  }

  close(){
    this.hideSideNav.emit(false);
  }

  goToBranches(){    
    window.open('https://www.avenirenergy.ca/about-us-branches', "_blank");
  }

  openOrderPropaneSite() {
    if (this.isLoggedIn) {
      const modal = this.modalService.open(OrderRequestModalComponent, { size: 'lg' });
      const modalRef = modal.componentInstance as OrderRequestModalComponent;
      modalRef.customerId = parseInt(this.customerId, 10);
    } else {
      this.router.navigateByUrl(buildUrl(SITE_LINKS.ROOT));
    }
    this.hideSideNav.emit(false);
  }

  openContactUsSite() {
    window.open(EXTERNAL_LINKS.CONTACT_US, '_blank')
  }

}
